import { Component, OnInit } from '@angular/core';
import { PopoverRef } from '../popover/popover-ref';
import { TILE_TYPE, TileDef, TileService } from '../../services/tile.service';
import { InitializationService } from 'src/app/services/initialization.service';

@Component({
    selector: 'app-add-tile',
    templateUrl: './add-tile.component.html',
    styleUrls: ['./add-tile.component.scss'],
})
export class AddTileComponent implements OnInit {
    currentTiles: TileDef[] = [];

    constructor(
        public popoverRef: PopoverRef,
        private tilesService: TileService,
        private initialization: InitializationService
    ) {
        if (this.popoverRef) {
            this.initializePopoverData();
        }
    }

    ngOnInit() {
        this.initTileList();
    }

    /**
     * Closes the overlay
     */
    close(): void {
        this.popoverRef.close(null);
    }

    /**
     * On Tile toggle event;
     * @param tile
     */
    onTileToggle(tile: TileDef) {
        if (tile.selected) {
            return;
        }
        if (tile.type === TILE_TYPE.MVP) {
            this.tilesService.toggleMVPTile(tile.id);
            return;
        }
        this.tilesService.toggleTile(tile);
        this.initTileList();
    }

    /**
     * Initializes the tile list by retrieving the current tile list from the tile-service.
     *
     * Then sort the tiles according to their addTile idx so they always have the same ordering
     * @private
     */
    private initTileList(): void {
        this.initialization.getWithCache().subscribe(
            (data) => {
                let isVisionUser = false;
                if ('product_name' in data) {
                    isVisionUser = data.product_name.toLowerCase().includes('vision');
                }

                const currentTiles = this.tilesService.getCurrentTiles(isVisionUser);
                const defaultTiles = this.tilesService.getDefaultTiles();

                const tilesWithOriginalKeys = currentTiles.map((currentTile) => {
                    const defaultTile = defaultTiles.find((dt) => dt.type === currentTile.type);
                    return {
                        ...currentTile,
                        title: defaultTile ? defaultTile.title : currentTile.title,
                        info: defaultTile ? defaultTile.info : currentTile.info,
                    };
                });

                this.tilesService
                    .translateTiles(tilesWithOriginalKeys)
                    .subscribe((translatedTiles) => {
                        this.currentTiles = translatedTiles.sort((a, b) => a.addIndex - b.addIndex);
                    });
            },
            (error) => {
                console.error(error);
            }
        );
    }

    /**
     * Overlay data init
     * @private
     */
    private initializePopoverData() {
        this.popoverRef.overlay.backdropClick().subscribe(() => {
            this.close();
        });
    }
}
